import {Component, Inject, OnDestroy} from '@angular/core';
import {FirmwareService} from "../../../../services/firmware.service";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {AbstractProdForm, ProdFormField, ProdFormFieldType, ProdFormValidators, RequiredValidator} from 'prod-form';
import {ProdDialogData} from 'prod-dialog';
import {FirmwareTypeService} from "../../../../services/firmware-type.service";
import {OrganizationService} from "../../../../services/organization.service";
import {DeviceTypeService} from "../../../../services/device-type.service";
import {FormGroup} from "@angular/forms";
import {Subscription} from "rxjs";
import {Role} from "../../../../dip/role";
import {RoleService} from "../../../../services/role.service";
import {DipColumn} from "../../../../dip/dip-column";
import {ProdGridColumnType} from 'prod-grid';
import {TranslateService} from "@ngx-translate/core";


@Component({
  selector: 'app-firmware-form',
  templateUrl: './firmware-form.component.html'
})
export class FirmwareFormComponent extends AbstractProdForm implements OnDestroy {
  title: string = this.translate.instant('firmware.form.title');
  form: FormGroup;
  typeChangeSubscription$: Subscription;
  private isFieldsEditable: boolean = this.roleService.hasRole([Role.ROLE_SYS]);
  fields: ProdFormField[] = [
    ProdFormField.create({
      name: 'header',
      label: this.translate.instant('firmware.form.header'),
      type: ProdFormFieldType.TEXT,
      validators: new ProdFormValidators([
        new RequiredValidator()
      ]),
      isEditable: this.isFieldsEditable
    }),
    ProdFormField.create({
      name: 'version',
      label: this.translate.instant('firmware.form.version'),
      type: ProdFormFieldType.TEXT,
      validators: new ProdFormValidators([
        new RequiredValidator()
      ]),
      isEditable: this.isFieldsEditable
    }),
    ProdFormField.create({
      name: 'type',
      label: this.translate.instant('firmware.form.type'),
      type: ProdFormFieldType.SELECT,
      validators: new ProdFormValidators([
        new RequiredValidator()
      ]),
      selectParameters: {
        selectDataService: FirmwareTypeService,
        isMulti: false,
        isNarrowDown: false,
        isComplete: true
      },
      isEditable: this.isFieldsEditable
    }),
    ProdFormField.create({
      name: 'deviceType',
      label: this.translate.instant('firmware.form.device_type'),
      type: ProdFormFieldType.SELECT,
      validators: new ProdFormValidators([
        new RequiredValidator()
      ]),
      selectParameters: {
        selectDataService: DeviceTypeService,
        isNarrowDown: true,
        isMulti: false,
        isComplete: true
      },
      isEditable: this.isFieldsEditable
    }),
    ProdFormField.create({
      name: 'file',
      label: this.translate.instant('firmware.form.file'),
      type: ProdFormFieldType.FILE_UPLOAD,
      validators: new ProdFormValidators([
        new RequiredValidator()
      ]),
      isEditable: false,
    }),
    ProdFormField.create({
      name: 'organizations',
      label: this.translate.instant('firmware.form.organizations'),
      type: ProdFormFieldType.GRID,
      gridParameter: {
        service: OrganizationService,
        displayColumn: DipColumn.get({property: 'name', type: ProdGridColumnType.STRING}),
      },
      isEditable: this.isFieldsEditable
    })
  ];


  constructor(dialogRef: MatDialogRef<FirmwareFormComponent>,
              @Inject(MAT_DIALOG_DATA) public dialogData: ProdDialogData,
              override dataService: FirmwareService,
              private roleService: RoleService,
              private translate: TranslateService) {
    super();
  }

  onFormOutput(form) {
    if (form.get('type').value === 1) form.get('organizations').disable();

    this.typeChangeSubscription$ = form.get('type').valueChanges.subscribe(value => {
      if (value === 1) {
        form.get('organizations').disable();
      } else {
        form.get('organizations').enable();
      }
    })
  }

  ngOnDestroy() {
    if (this.typeChangeSubscription$) this.typeChangeSubscription$.unsubscribe();
  }
}
